import { Link } from "react-router-dom";

const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "LKR",
});

export default function ProductCardRowStyleTwo({ className, datas }) {
  const currentDate = new Date();

  const hasSpecialPrice =
    datas.minsp !== null &&
    datas.maxsp !== null &&
    datas.discount_start_date !== null &&
    datas.discount_end_date !== null &&
    currentDate >= new Date(datas.discount_start_date) &&
    currentDate <= new Date(datas.discount_end_date);

  let price;
  let oldPrice;
  let discountPercent;

  if (hasSpecialPrice) {
    if (datas.minsp === datas.maxsp) {
      oldPrice = formatter.format(datas.minp);
      price = formatter.format(datas.minsp);
    } else {
      let p1 = formatter.format(datas.minp);
      let p2 = formatter.format(datas.maxp);
      oldPrice = p1 + "-" + p2;
      let sp1 = formatter.format(datas.minsp);
      let sp2 = formatter.format(datas.maxsp);
      price = sp1 + "-" + sp2;
    }
    discountPercent = Math.round(
      ((datas.minp - datas.minsp) / datas.minp) * 100
    );
  } else {
    if (datas.minp === datas.maxp) {
      price = formatter.format(datas.maxp);
    } else {
      let p1 = formatter.format(datas.minp);
      let p2 = formatter.format(datas.maxp);
      price = p1 + "-" + p2;
    }
  }

  return (
    <div
      data-aos="fade-up"
      className={`product-card-row-two w-full  ${className || ""}`}
    >
      <div className="w-full h-[105px] bg-white border border-primarygray px-5 ">
        <div className="w-full h-full flex space-x-5 justify-center items-center">
          <div className="w-[75px] h-[75px]">
            <img
              src={process.env.REACT_APP_IMAGE_FOLDER + `/` + datas.name}
              alt=""
              className="w-full h-full object-cover"
            />
          </div>
          <div className="flex-1 h-full flex flex-col justify-center ">
            <Link to={`/single-product/${datas.id}`}>
              <p className="title sm:text-[15px] text-[13px] font-600 text-qblack leading-[24px] line-clamp-1 hover:text-blue-600">
                {datas.p_name}
              </p>
            </Link>

            <div className="flex items-end space-x-2 mt-2">
              <span className="text-lg font-bold text-qred">{price}</span>
              {hasSpecialPrice && (
                <span className="text-base text-gray-400 line-through">
                  {oldPrice}
                </span>
              )}
              {hasSpecialPrice && (
                <span className="text-xs bg-green-100 text-green-700 rounded px-2 py-0.5 font-semibold">
                  {discountPercent}% OFF
                </span>
              )}
            </div>
            <div className="flex items-center gap-2 text-xs text-gray-600 mt-1 ml-2">
              Or 3 x
              <span className="font-semibold text-qblack">
                {formatter.format(
                  Math.ceil(
                    ((hasSpecialPrice ? datas.minsp : datas.minp) / 3) * 1.11
                  )
                )}
              </span>
              <img
                src={`${process.env.PUBLIC_URL}/assets/images/koko.png.webp`}
                alt="KOKO"
                className="w-8 h-8 object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
